import React from "react";
import { Form, Input, Row, Col, DatePicker } from "antd";
import {
  opExerciseNameFormRules,
  opExerciseTypeFormRules,
  opFrequencyFormRules,
  opIntensityFormRules,
} from "./exerciseFieldValidation";

const ExerciseFormFields = ({ disabled = false, showVideo = false, disableStartDate = false }) => {
  const nameRules = disabled ? [] : opExerciseNameFormRules;
  const typeRules = disabled ? [] : opExerciseTypeFormRules;
  return (
    <>
      <Form.Item label="Exercise Name" name="name" rules={nameRules}>
        <Input placeholder="Enter Exercise Name" disabled={disabled} />
      </Form.Item>

      <Form.Item label="Exercise Type" name="type" rules={typeRules}>
        <Input placeholder="Enter Exercise Type" disabled={disabled} />
      </Form.Item>

      <Row gutter={16}>
        <Col xs={24} sm={24} md={12}>
          <Form.Item
            label="Frequency"
            name="frequency"
            rules={opFrequencyFormRules}
          >
            <Input type="number" placeholder="Frequency" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12}>
          <Form.Item
            label="Intensity"
            name="intensity"
            rules={opIntensityFormRules}
          >
            <Input type="number" placeholder="Intensity" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} sm={24} md={12}>
          <Form.Item
            label="Start Date"
            name="startDate"
            // rules={[{ required: true, message: "Start Date is required" }]}
          >
            <DatePicker style={{ width: "100%" }}disabled={disableStartDate} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12}>
          <Form.Item
            label="No. of Days"
            name="duration"
            rules={[
  {
    validator: (_, value) => {
          if (value === undefined || value === null || value === "") {
            return Promise.resolve();
          }
          if (Number(value) <= 0) {
            return Promise.reject("No. of Days must be a positive number");
          }
    
          return Promise.resolve();
        },
      },
    ]}

          >
            <Input type="number" placeholder="Duration" />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default ExerciseFormFields;
